var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { DatePicker } from 'syf-component-library/ui/patterns/DatePicker';
var CalendarField = styled(DatePicker)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export default CalendarField;
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map